import { buildSectionDeleteUpdate } from '@griply/services';
import { useCallback } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

import { useUpdateGoal } from './use-update-goal';

export const useDeleteGoalSection = () => {
  const { submit: updateGoal } = useUpdateGoal();

  return useCallback(
    (goal: Goal, sectionId: ID, tasks?: Task[]) => {
      updateGoal(buildSectionDeleteUpdate(goal, sectionId, tasks));
    },
    [updateGoal],
  );
};
